export const initWebAdProvider = (externalIdentifier: string): void => {
  const placementId = Number(import.meta.env.VITE_WEB_AD_PROVIDER_PLACEMENT_ID)

  // eslint-disable-next-line no-undef
  AyetVideoSdk.init(placementId, externalIdentifier).catch((error: unknown): void => {
    console.error(error)
  })
}
